import simpleRest from "@refinedev/simple-rest";

/**
 * simple-rest sends pagination as _start/_end and sorting as _sort/_order, and reads the total
 * from X-Total-Count. The backend's ListQuery helper implements exactly that convention, so no
 * custom data provider is needed here.
 */
export const dataProvider = simpleRest("/api");
